import { zodFallback } from '../../zod/fallback';
import { zodForgivingSchema } from '../../zod/forgivingSchema';
import { ClassificationLocation } from '../snapshot/classificationLocation';
import z from 'zod';

export const WeightWithoutScanReason = z.enum([
    'other',
    'customerNegated',
    'barcodeArticleAdded',
    'personalItemAdded',
    'pluArticleAdded',
    'cancelled',
]);
export type WeightWithoutScanReason = z.infer<typeof WeightWithoutScanReason>;

export const WeightWithoutScanEventSource = z.enum(['none', 'objectDetection', 'scale']);
export type WeightWithoutScanEventSource = z.infer<typeof WeightWithoutScanEventSource>;

export const WeightWithoutScanDetectionModel = z.object({
    location: ClassificationLocation,
    class: z.object({
        network: z.unknown().nullish(),
        name: z.string(),
        probability: z.number(),
    }),
});
export type WeightWithoutScanDetectionModel = z.infer<typeof WeightWithoutScanDetectionModel>;

export const WeightWithoutScanModel = zodForgivingSchema(
    z.object({
        createdOn: z.coerce.date(),
        customerConfirmation: zodFallback(WeightWithoutScanReason, 'unknown'),
        detectedObject: WeightWithoutScanDetectionModel.nullish(),
        evaluationDelaySeconds: z.int(),
        eventSource: zodFallback(WeightWithoutScanEventSource, 'unknown'),
        isCustomerConfirmationRequired: z.boolean(),
        isSilent: z.boolean(),
        lastScanOn: z.coerce.date().nullish(),
        lastObjectDetectionOn: z.coerce.date().nullish(),
        lastWeightDeviationOn: z.coerce.date().nullish(),
        modelGuid: z.guid(),
        modifiedOn: z.coerce.date(),
        observationStartedOn: z.coerce.date().nullish(),
        observationStoppedOn: z.coerce.date().nullish(),
        snapshotBeforeEventPath: z.string().nullish(),
        snapshotPath: z.string().nullish(),
        weight: z.int(),
        weightThreshold: z.int(),
    }),
);
export type WeightWithoutScanModel = z.infer<typeof WeightWithoutScanModel>;

export const SessionWeightWithoutScanNotificationModel = zodForgivingSchema(
    z.object({
        storeGuid: z.guid(),
        sessionGuid: z.guid(),
        model: WeightWithoutScanModel,
    }),
);
export type SessionWeightWithoutScanNotificationModel = z.infer<typeof SessionWeightWithoutScanNotificationModel>;
